"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrowserSpaRoute = void 0;
exports.BrowserSpaRoute = {
    /**
     * **backendCode**: provides a hint to the frontend about how to reach the backend app--what apiBaseUrl to use. The frontend needs to know how to resolve
     *  this value. Eg, for spanggle, this value indicates which wranggle subdomain to use (Eg, "preview-abc123") or an underscore "_" for none.
     *
     * **organizationUid**: wranggle account (or perhaps later an alias for it)
     *
     * **pageDefUid**: expiring token that defines what data buckets are included on the page
     *
     * **viewType**: value for use by the frontend app, intended to give it an idea of what view/component to render initially
     */
    Landing_SyncOrgExpiringPage: '/pages/:backendCode/org/:organizationUid/sync/:pageDefUid/view/:viewType',
};
//# sourceMappingURL=routes-browser-spa.js.map